import React from 'react'

import { styled } from '@material-ui/core/styles'

import { useAppConfig } from 'artkive/contexts/AppConfigContext'

const Bar = styled('div')(({ theme }) => ({
  position: 'fixed',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 1500,
  padding: theme.spacing(1, 2),
  backgroundColor: theme.colors.yellow[100],
  color: theme.colors.black,
  textAlign: 'center',
  fontWeight: 600,
}))

const ExitLink = styled('a')({
  marginLeft: 12,
  textDecoration: 'underline',
  color: 'inherit',
})

// Admin-only: env.salePreview is only ever set server-side for admins.
const SalePreviewRibbon = () => {
  const {
    env: { salePreview },
  } = useAppConfig()

  if (!salePreview) return null

  return (
    <Bar>
      Previewing sale: {salePreview.name} ({salePreview.priceLabel} tier)
      <ExitLink href='/?sale_preview=exit'>Exit Preview</ExitLink>
    </Bar>
  )
}

export default SalePreviewRibbon
